import { gql } from "@apollo/client";

export const DISMISS_CANONICAL_ENTIY_MUTATION = gql`
  mutation DismissCanonicalEntity(
    $learningEvidence: ID
    $linkedCanonicalEntity: ID
  ) {
    dismissCanonicalEntity(
      learningEvidence: $learningEvidence
      linkedCanonicalEntity: $linkedCanonicalEntity
    ) {
      success
      message
    }
  }
`;
export const ADD_NEW_LINKED_ENTITY_MUTATION = gql`
  mutation AddNewLinkedEntity(
    $canonicalEntity: ID!
    $reasoning: String!
    $assignmentFeedback: ID
    $assignmentQuestionFeedback: ID
  ) {
    addNewLinkedEntity(
      canonicalEntity: $canonicalEntity
      reasoning: $reasoning
      assignmentFeedback: $assignmentFeedback
      assignmentQuestionFeedback: $assignmentQuestionFeedback
    ) {
      success
      message
      canonicalEntityInsights {
        id
        label
        explanation
        entityType
        supportingText
        processed
        associatedObjectId
      }
    }
  }
`;
export const ADD_NEW_LEARNING_SIGNAL_MUTATION = gql`
  mutation AddLearningSignal(
    $canonicalEntity: ID
    $entityType: String!
    $reasoning: String!
    $answer: ID!
  ) {
    addNewLearningSignal(
      canonicalEntity: $canonicalEntity
      entityType: $entityType
      reasoning: $reasoning
      answer: $answer
    ) {
      success
      message
      canonicalEntityInsights {
        id
        label
        explanation
        entityType
        supportingText
        processed
        associatedObjectId
      }
    }
  }
`;
